import { render, staticRenderFns } from "./cashier.vue?vue&type=template&id=c5970c52&scoped=true&"
import script from "./cashier.vue?vue&type=script&lang=js&"
export * from "./cashier.vue?vue&type=script&lang=js&"
import style0 from "./cashier.vue?vue&type=style&index=0&id=c5970c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5970c52",
  null
  
)

export default component.exports